import { render, staticRenderFns } from "./NewDeliveryRequest.vue?vue&type=template&id=84d1ca8a"
import script from "./NewDeliveryRequest.vue?vue&type=script&lang=js"
export * from "./NewDeliveryRequest.vue?vue&type=script&lang=js"
import style0 from "./NewDeliveryRequest.vue?vue&type=style&index=0&id=84d1ca8a&prod&module=true&lang=scss"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports